import './App.css';
// import * as THREE from 'three';
// import { useEffect, useRef } from "react";
import KaleidoscopeCanvas from './components/KaleidoscopeCanvas';
// import { eventDispatcher, drawRectangle } from "./utils/utils";

function App() {
  return (
    <div className="App">
      <div className='kaleidoscope-wrapper' >
        <KaleidoscopeCanvas 
        options={{
          mode: 'static',
          motion: '10',
          segments: '12',
          scale: '0.8',
          imageSrc: './chanel.jpg',
        }}
        />
      </div>      
    </div>
  );
}

export default App;
